import { Controller } from "@hotwired/stimulus"

// 必須フィールドが空のときsubmitボタンを無効化するコントローラー
export default class extends Controller {
  static targets = ["required", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    const allFilled = this.requiredTargets.every(el => el.value.trim() !== "")
    this.submitTargets.forEach(btn => {
      btn.disabled = !allFilled
      btn.classList.toggle("opacity-50", !allFilled)
      btn.classList.toggle("cursor-not-allowed", !allFilled)
      btn.classList.toggle("cursor-pointer", allFilled)
    })
  }
}
